import b from './b.json'
import c from './c.json'
import d from './d.json'
import j from './j.json'
import u from './u.json'
import v from './v.json'
import w from './w.json'
import z from './z.json'
import h from './h.json'

import t2 from './definitions.json'

import a from './a.json'

export const Templates = a.concat(b, c, d, h, j, u, v, w, z)
